import Printers from "@/views/admin/printer/Printers";

export default {
  path: "printers/list",
  name: "printers",
  component: Printers,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
